import api from '@/api'

const issue = {
  get(params) {
    return api.get(`/issue/number`, {
      params: params,
    })
  },
  getV2(params) {
    return api.get(`/issue/v2`, {
      params: params,
    })
  },
  list(params) {
    return api.get(`/issue`, {
      params: params,
    })
  },
  listSd() {
    return api.get(`/issue/sd`)
  },
  listSdArea(params) {
    return api.get(`/issue/sd-area`, {
      params: params,
    })
  },
  listSfcMatch(number) {
    return api.get(`/issue/sfc/${number}`)
  },
}

export default issue
